export default "__VITE_ASSET__CJa9V5UU__"